export enum NewHomeEmailSentStatus {
  Sent = 'Sent',
  NotRequested = 'Not Requested',
  Requested = 'Requested',
}
